import { types } from '../actions/types';

export const ClientReducer = (
  state = {
    get: null,
    getById: null,
    create: null,
    update: null,
    deleteById: null,
    download: null,
    getLeads: null,
    getOffers: null,
    getQuotations: null,
  },
  action,
) => {
  switch (action.type) {
    case types.cmGetClients:
      return {
        ...state,
        get: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.cmGetClientById:
      return {
        ...state,
        getById: action.payload
          ? {
              status: action.payload?.status,
              message: action.payload?.message,
              data: action.payload?.data,
            }
          : null,
      };
    case types.cmCreateClient:
      return {
        ...state,
        create: action.payload
          ? {
              status: action.payload?.status,
              message: action.payload?.message,
              data: action.payload?.data,
            }
          : null,
      };
    case types.cmUpdateClient:
      return {
        ...state,
        update: action.payload
          ? {
              status: action.payload?.status,
              message: action.payload?.message,
              data: action.payload?.data,
            }
          : null,
      };
    case types.cmDeleteClientById:
      return {
        ...state,
        get: {
          ...state.get,
          data: state.get.data.filter(
            (client) => client.id !== action.payload?.clientId,
          ),
        },
        deleteById: action.payload
          ? {
              status: action.payload?.status,
              message: action.payload?.message,
              data: action.payload?.data,
              clientId: action.payload?.clientId,
            }
          : null,
      };
    case types.cmDownloadClients:
      return {
        ...state,
        download: action.payload ? action.payload : null,
      };
    case types.cmGetClientLeads:
      return {
        ...state,
        getLeads: action.payload
          ? {
              status: action.payload?.status,
              message: action.payload?.message,
              data: action.payload?.data,
            }
          : null,
      };
    case types.cmGetClientOffers:
      return {
        ...state,
        getOffers: action.payload
          ? {
              status: action.payload?.status,
              message: action.payload?.message,
              data: action.payload?.data,
            }
          : null,
      };
    case types.cmGetClientQuotations:
      return {
        ...state,
        getQuotations: action.payload
          ? {
              status: action.payload?.status,
              message: action.payload?.message,
              data: action.payload?.data,
            }
          : null,
      };
    default:
      return state;
  }
};
